import React from 'react';

/**
 * 액상화위험지수(LPI) 게이지.
 *
 * 등급 경계는 Iwasaki(1978) 기준을 따른다.
 *   LPI = 0        매우낮음
 *   0 < LPI ≤ 5    낮음
 *   5 < LPI ≤ 15   높음
 *   LPI > 15       매우높음
 */
const BANDS = [
  { key: '매우낮음', range: '0', bg: 'bg-green-100', text: 'text-green-700', active: 'bg-green-500' },
  { key: '낮음', range: '0–5', bg: 'bg-yellow-100', text: 'text-yellow-700', active: 'bg-yellow-500' },
  { key: '높음', range: '5–15', bg: 'bg-orange-100', text: 'text-orange-700', active: 'bg-orange-500' },
  { key: '매우높음', range: '15+', bg: 'bg-red-100', text: 'text-red-700', active: 'bg-red-500' },
];

const VALUE_TONE = {
  매우낮음: 'text-green-600',
  낮음: 'text-yellow-600',
  높음: 'text-orange-600',
  매우높음: 'text-red-600',
};

const LPIGauge = ({ value, level }) => {
  const numeric = Number(value ?? 0);

  return (
    <div>
      <div className="flex items-end justify-between">
        <div className={`text-4xl font-extrabold tabular-nums ${VALUE_TONE[level] || 'text-gray-800'}`}>
          {numeric.toFixed(1)}
        </div>
        <div className="text-sm text-gray-500 pb-1">
          위험도 <span className="font-semibold text-gray-800">{level}</span>
        </div>
      </div>

      <div className="mt-3 grid grid-cols-4 gap-1">
        {BANDS.map((b) => {
          const isActive = b.key === level;
          return (
            <div
              key={b.key}
              className={`rounded px-1.5 py-1.5 text-center transition
                ${isActive ? `${b.active} text-white` : `${b.bg} ${b.text}`}`}
            >
              <div className="text-[10px] leading-tight opacity-80">{b.range}</div>
              <div className="text-[11px] font-semibold leading-tight">{b.key}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LPIGauge;
